import React from 'react'

const Icon = (props) => {
  return (<i className={`fa fa-${props.name} ${props.className || ''}`} aria-hidden='true'>{props.children}</i>)
}

export default Icon
